import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import DealerApplicationForm from './DealerApplicationForm'

const Apply = () => (
  <Grid>
    <Row>
      <Col xs={12} mdOffset={2} md={8}>
        <h1>Become a Dealer</h1>

        <p>
          Contact <b>CarFinder.com</b> today to find out how we can increase
          your business and make technology work for you.
        </p>

        <p>
          <b>Link Your Inventory Automatically - </b>
          A cost effective way to make your vehicles stand out and increase your
          floor traffic and sales.<br />
          We are integrated with the major data services or can easily tie in with yours.
        </p>

        <p>
          <b>Leads - </b>Expand your reach and product mix.&nbsp; You choose the
          regional coverage and vehicle types for your incoming leads.&nbsp;
          Every dealer can improve their pre-owned inventory turnover rates by
          buying their cars with customer deposits in hand.&nbsp; Ask about
          rapid on sign-up process.
        </p>
        <p>
          <b>Tools -&nbsp; </b>Manage your leads with our free web tools.&nbsp;
          The LeadManager lets you preview incoming leads, update client
          details, attach vehicle search and auction reports and autorespond
          with customized emails.&nbsp; Progress tracking and reminder systems
          help you use your time in the most effective manner.
        </p>
        
        <p>
          To find out more and for a free demonstration, please fill out the
          following. <br />Once we get it, a company representative will contact
          you directly to identify how we can help and get you started on the
          CarFinder team.
        </p>
      </Col>
      <Col xs={12} mdOffset={2} md={8}>
        <DealerApplicationForm title="Contact Information" />
      </Col>
    </Row>
  </Grid>
)
export default Apply



// WEBPACK FOOTER //
// ./src/components/Apply.js